import Product from "./Product.js";
import Order from "./Order.js";
import HttpClient from "./HttpClient.js";
import Row from "./Row.js";
import Stack from "./Stack.js";
import Structure from "./Structure.js";
import Attachment from "./Attachment";
import Helper from "./Helper";
export default class Pallet {
  constructor(pallet) {
    if (!pallet) return;
    this.auto_update = pallet.auto_update;
    this.comment = pallet.comment;
    this.company_id = pallet.comment;
    this.created_at = pallet.created_at;
    this.customer_name = pallet.customer_name;
    this.dispatch_priority = pallet.dispatch_priority;
    this.height = pallet.height;
    this.id = pallet.id;
    this.is_turned = pallet.is_turned;
    this.length = pallet.length;
    this.number = pallet.number;
    this.order_number = pallet.order_number;
    this.pallet_height = pallet.pallet_height;
    this.printable = pallet.printable;
    this.products =
      pallet.products != null ? this.getProducts(pallet.products) : [];
    this.spacing_between = pallet.spacing_between;
    this.spacing_ends = pallet.spacing_ends;
    this.spacing_sides = pallet.spacing_sides;
    this.status = pallet.status;
    this.truck_id = pallet.truck_id;
    this.truck_x = pallet.truck_x;
    this.truck_y = pallet.truck_y;
    this.updated_at = pallet.truck_y;
    this.width = pallet.width;
    this.temporary = pallet.temporary;
    this.pallet_structure = pallet.pallet_structure;
    this.max_weight = pallet.max_weight;
    this.max_height = pallet.max_height;
    this.products_count = pallet.products_count;
    this.comment = pallet.comment;
    this.owned = pallet.owned;
    this.pallet_structure = pallet.pallet_structure
      ? new Structure(pallet.pallet_structure)
      : null;
    this.attachments = this.getAttachements(pallet.attachments);
    this.searched = !pallet.searched ? false : true;
  }

  getAttachements(problemAttachements) {
    const attachments = [];
    if (problemAttachements) {
      problemAttachements.sort((a, b) => {
        //gets dates of expected soonest products
        const dateA = new Date(a.created_at);
        const dateB = new Date(b.created_at);
        //get oldest first
        return dateB.getTime() - dateA.getTime();
      })
      for (const attachment of problemAttachements) {
        attachments.push(new Attachment(attachment));
      }
    }
    return attachments;
  }

  static async loadPallet(palletId, params) {
    const client = new HttpClient();
    const response = await client.instance.get(`pallets/${palletId}`, {
      params: params
    });
    return new Pallet(response.data);
  }

  static async loadPallets(params) {
    const client = new HttpClient();
    const response = await client.instance.get("pallets", {
      params: params
    });
    const pallets = [];
    const lastPage = response.data.last_page;
    response.data.data.forEach(pallet => {
      pallets.push(new Pallet(pallet));
    });
    return { pallets, lastPage };
  }

  getProducts(productObj) {
    let products = [];
    productObj.forEach(product => {
      products.push(new Product(product));
    });
    return products;
  }

  getYear() {
    if (!this.number) {
      return "";
    }
    return this.number.substring(this.number.length - 6, this.number.length - 4);
  }

  getNumber() {
    if (!this.number) {
      return "";
    }
    if (this.number.length == 13) {
      return this.number.substring(this.number.length - 7, this.number.length);
    }
    return this.number.substring(this.number.length - 4, this.number.length);
  }

  getLength() {
    if (this.is_turned) {
      return this.width;
    }
    return this.length;
  }

  getWidth() {
    if (this.is_turned) {
      return this.length;
    }
    return this.width;
  }

  getHeight(user) {
    let maxHeight = 0;
    this.products.forEach(product => {
      maxHeight = Math.max(maxHeight, product.getHeight() + product.z);
    });
    if (user) {
      if (user.company_id == 7) {
        return 100 + 20 + maxHeight + 20;
      }
    }
    return maxHeight + this.pallet_height;
  }

  getWeight() {
    let weight = 0;
    this.products.forEach(product => {
      weight += product.weight;
    });
    return weight;
  }

  productsFit() {
    const { length, width } = this.minDimensions();
    return Math.round(this.length) >= Math.round(length) && Math.round(this.width) >= Math.round(width);
  }

  toString(palletText, user) {
    const palletWeight = this.getWeight();
    const bruto = (this.pallet_structure) ? `, bruto - ${palletWeight + this.pallet_structure.getPalletWeight(this)}` : "";
    palletText = palletText ? palletText : "";
    return `${palletText} ${this.getNumber()} ${this.length}x${
      this.width
      } H=${this.getHeight(user)}, neto - ${palletWeight}kg ${bruto}kg`;
  }

  getDispatchColor(orders, colors, companyId) {
    if(companyId == 7){
      const grouped = Helper.groupBy(orders, "delivery_address");
      const order = this.getOrder(orders);
      let counter = 0;
      for(let key in grouped){
        const orderGroup = grouped[key];
        if(orderGroup.includes(order)){
          return colors[counter];
        }
        counter++;
      }
    }
    const order = this.getOrder(orders);
    const orderIndex = orders.indexOf(order);
    return colors[orderIndex];
  }

  getOrder(orders) {
    const order = orders.find(e => {
      if (this.order_number) {
        const orderNumbers = this.order_number.split(",");
        const orderNumber = orderNumbers[0];
        if (e.production_id == orderNumber) return true;
        if (e.offer_id == orderNumber) return true;
        return false;
      }
    });
    if (!order) return orders[0];
    return order;
  }

  async updateNumber(number) {
    const client = new HttpClient();
    try {
      await client.instance.put(`pallets/${this.id}/number`, {
        number: number
      });
      return true;
    } catch{
      alert("Įvestas numeris neteisingas arba jau egzistuoja!");
      return false;
    }
  }

  async save() {
    const client = new HttpClient();
    const response = await client.instance.put(`pallets/${this.id}`, this);
    return response.data;
  }

  /**
   * moves products away from pallet, then deletes this pallet
   */
  async remove() {
    const client = new HttpClient();
    await client.instance.delete(`pallets/${this.id}`);
    return 1;
  }

  async removeFromTruck(truck, pallets) {
    const client = new HttpClient();
    await client.instance.put(`pallets/${this.id}`, {
      truck_x: null,
      truck_y: null,
      truck_id: null
    });
    const removeIndex = truck.pallets.indexOf(this);
    truck.pallets.splice(removeIndex, 1);
    const truckPallets = truck.getTruckPallets(pallets);
    const orders = Order.getOrdersFromPallets(truckPallets);
    truck.orders = Order.getOrdersString(orders);
    truck.customers = Order.getCustomersString(orders);
    await truck.save();
    const response = await truck.optimize(truck.pallets);
    return response;
  }

  /**
   * takes all the items contained in the pallet
   * and checks if already working with. helper method
   * @param stacks - all the stacks of items
   * @param current stack
   * @return false if is not already portraied
   */
  static alreadyShowed(stacks, stack) {
    let productIds = [];
    stacks.forEach(stacksRow => {
      stacksRow.forEach(stacksCell => {
        productIds.push(stacksCell.id);
      });
    });
    let alreadyContains = false;
    stack.forEach(stackItem => {
      if (productIds.includes(stackItem.id)) {
        alreadyContains = true;
      }
    });
    return alreadyContains;
  }

  /**
   * recalculates products on both affective pallets
   * @param pallets
   * @param from
   * @param to
   * @param movedProduct
   */
  static recalculatePallets(pallets, from, to, movedProduct) {
    pallets[from].moveOld();
    pallets[to].moveOld();
    const movedToInNewPalletIndex = pallets[to].products
      .map(e => {
        return e.id;
      })
      .indexOf(movedProduct.id);
    pallets[to].products.splice(movedToInNewPalletIndex); // find item in recalculated pallet and remove it
    const recalculatedPallets = pallets[from].products.concat(
      pallets[to].products
    );
    return recalculatedPallets;
  }

  /**
   * gets layout of given pallet
   */
  getLayout() {
    let layout = [];
    let stacks = [];
    //get layout by stacks of products
    this.products.forEach(product => {
      let stack = this.products.filter(
        e => e.x === product.x && e.y === product.y
      );
      //check if there are no dublicates
      if (!Pallet.alreadyShowed(stacks, stack)) {
        stacks.push(stack);
      }
    });
    let index = 0;
    stacks.forEach(stack => {
      stack.sort((a, b) => {
        return a.getWidth() - b.getWidth();
      });
      let stackedItems = null;
      // if there are products on top of this product save them in layout
      if (stack.length > 1) {
        // text = this.getStackedText(stack, vue);
        stack.sort((a, b) => {
          return a.z - b.z;
        });
        stackedItems = stack.splice(1, stack.length);
      }
      layout.push({
        x: Math.floor(stack[0].x),
        y: Math.floor(stack[0].y),
        w: Math.floor(stack[0].getWidth()),
        h: Math.floor(stack[0].depth),
        i: "" + index,
        menu: false,
        dialog: false,
        text: "text",
        product: stack[0],
        stacked: stackedItems
      });
      index++;
    });
    return layout;
  }

  /**
   * moves product on the pallet
   * @param layout
   * @param pallet
   */
  move(rows) {
    const recalculatedRows = Row.getRows(Row.getProducts(rows));
    let currentY = this.spacing_sides; // y coordinate of product currently counting
    recalculatedRows.forEach(row => {
      let currentX = this.spacing_ends ? this.spacing_ends : 0; // x coordinate of product currently counting
      row.stacks.sort((a, b) => {
        return a.x - b.x;
      });
      row.stacks.forEach(stack => {
        stack.updateCoordinates(currentX, currentY);
        currentX += stack.getBottomProduct().getWidth();
        if (row.stacks.length == 2) {
          let takenUpSpace = this.spacing_ends * 2;
          row.stacks.sort((a, b) => {
            return a.x - b.x;
          });
          row.stacks.forEach(stack => {
            takenUpSpace += stack.getBottomProduct().getWidth();
          });
          const longestRowLength = Row.getLongestRowLength(rows);
          if (takenUpSpace < longestRowLength) {
            //TODO longest row - spacing ends - this stack
            currentX =
              longestRowLength -
              this.spacing_ends -
              row.stacks[row.stacks.length - 1].getBottomProduct().getWidth();
          }
        }
      });
      currentY += row.getHeight() + this.spacing_between;
    });
    return recalculatedRows;
  }


  /**
   * moves product between other products
   * @param {*} rows
   * @param {*} stack
   * @param {*} between
   */
  moveBetween(oldRows, movingStack, between, offsets) {
    let products = Row.getProducts(oldRows);
    movingStack.products.forEach(product => {
      const removeIndex = products.map(e => e.id).indexOf(product.id);
      if (removeIndex) {
        products.splice(removeIndex, 1);
      }
    });
    const rows = Row.getRows(products);
    let rowIndex = null;
    //find where to shift
    //we are searching for the row we have moved
    const betweenSpace = between.y + between.height;
    for (let i = 0; i < rows.length; i++) {
      const rowTop = rows[i].getMovingTop(movingStack) + offsets.top;
      //if height matches, we heave found the row
      if (Math.round(betweenSpace) <= Math.round(rowTop)) {
        rowIndex = i;
        break;
      }
    }
    if (!rowIndex) {
      return oldRows;
    }
    //find old row and remove needed
    rows.forEach((row, i) => {
      row.stacks.forEach((stack, j) => {
        if (stack.products[0].id == movingStack.products[0].id) {
          //if row has more than one stack remove only that stack
          if (row.stacks.length > 1) {
            row.stacks.splice(j, 1);
          } else {
            // remove whole row
            rows.splice(i, 1);
          }
        }
      });
    });
    //get rows chunks
    const rowsStart = rows.slice(0, rowIndex);
    const rowsEnd = rows.slice(rowIndex);
    //create new row
    const newRowX = this.spacing_ends;
    const newRowY = between.y + between.height - offsets.top;
    const stack = new Stack(movingStack.products[0]); // create new stack for row (must initialize with only one product, then fill it)
    for (let i = 1; i < movingStack.products.length; i++) {
      stack.addToStack(movingStack.products[i]);
    }
    stack.updateCoordinates(newRowX, newRowY); //move whole stack to where it needs to be
    const insertingRow = new Row(stack, newRowY);
    //move rowsend chunk after insertion
    let currentY = newRowY + insertingRow.getHeight() + this.spacing_between;
    rowsEnd.forEach(row => {
      row.stacks.forEach(stack => {
        stack.updateCoordinates(stack.x, currentY);
      });
      currentY += row.getHeight() + this.spacing_between;
    });
    //rebuild array of rows
    return [...rowsStart, insertingRow, ...rowsEnd];
  }

  /**
   * stacks on product on top of other (row above this row)
   * @param {*} rows 
   * @param {*} movingStack 
   */
  moveOnTop(rows, movingStack) {
    let rowIndex = null;
    let stackIndex = null;
    rows.forEach((row, i) => {
      row.stacks.forEach((stack, j) => {
        if (stack.products[0].id == movingStack.products[0].id) {
          rowIndex = i - 1; // row on which we are moving this stack
          stackIndex = j; // remember to remove stack
        }
      });
    });
    if (rowIndex < 0) return;
    rows[rowIndex + 1].stacks.splice(stackIndex, 1);
    //add to leftest stack on found row
    rows[rowIndex].stacks[0].stackTop(movingStack);
    return rows;
  }

  /**
   * stacks product on other stack
   * @param {*} rows 
   * @param {*} movingStack 
   */
  moveOnProduct(rows, movingStack, moveToStack) {
    let fromRowIndex = null;
    let fromStackIndex = null;
    let toRowIndex = null;
    let toStackIndex = null;
    //find position of where to move
    rows.forEach((row, i) => {
      row.stacks.forEach((stack, j) => {
        //find position of what we are moving
        if (stack.products[0].id == movingStack.products[0].id) {
          fromRowIndex = i;
          fromStackIndex = j;
        }
        //find index of stack we are moving on top of
        if (stack.products[0].id == moveToStack.products[0].id) {
          toRowIndex = i; // find stack on which we are moving
          toStackIndex = j; //remember to remove stack
        }
      });
    });
    if (toRowIndex < 0) return;
    if (fromRowIndex < 0) return;
    //remove moved stack from rows
    rows[fromRowIndex].stacks.splice(fromStackIndex, 1);
    //move on top of stack
    rows[toRowIndex].stacks[toStackIndex].stackTop(movingStack);
    return rows;
  }

  /**
   * dissmantles stack
   * @param {*} rows 
   * @param {*} movingStack 
   */
  moveDown(oldRows, movingStack) {
    const rows = Row.getRows(Row.getProducts(oldRows));
    let rowIndex = null;
    let stackIndex = null;
    rows.forEach((row, i) => {
      row.stacks.forEach((stack, j) => {
        if (stack.products[0].id == movingStack.products[0].id) {
          rowIndex = i;
          stackIndex = j;
        }
      });
    });
    rows[rowIndex].stacks[stackIndex].products.splice(1);
    const rowsBefore = rows.slice(0, rowIndex + 1); // get rows before (take already existing too, just adjust it)
    const rowsAfter = rows.slice(rowIndex + 1);
    //move products to calculated space
    let newRows = [];
    let currentY = rowsBefore[rowsBefore.length - 1].getBottom() + this.spacing_between;
    for (let i = 1; i < movingStack.products.length; i++) {
      movingStack.products[i].z = 0;
      const newStack = new Stack(movingStack.products[i]);
      newStack.updateCoordinates(newStack.x, currentY);
      newRows.push(new Row(newStack, currentY));
      currentY += movingStack.products[i].depth + this.spacing_between; //move every product as new row
    }
    //recalculate below rows y
    rowsAfter.forEach(row => {
      row.stacks.forEach(stack => {
        stack.updateCoordinates(stack.x, currentY);
      });
      currentY += row.getHeight() + this.spacing_between;
    });
    return [...rowsBefore, ...newRows, ...rowsAfter];
  }

  /**
   * get min dimensions of pallet
   * @param pallet
   */
  minDimensions() {
    const rows = Pallet.getRows(this.products);
    const spacing_ends = this.spacing_ends ? this.spacing_ends : 0;
    let minLength = spacing_ends * 2;
    let minWidth = this.spacing_sides * 2;
    rows.forEach((row, rowIndex) => {
      let rowHeight = 0;
      let rowWidth = 0;
      row.sort((a, b) => {
        return a.x - b.x;
      });
      row.forEach(product => {
        if (product.z == 0) {
          rowHeight = Math.max(product.depth, rowHeight);
          rowWidth += product.getWidth() + spacing_ends * 2;
        }
      });
      minWidth += rowHeight;
      minLength = Math.max(rowWidth, minLength);
      if (rowIndex < rows.length - 1) minWidth += this.spacing_between;
    });

    return {
      length: minLength,
      width: minWidth
    };
  }

  /**
   * gets matrix of products (portrayed in rows as seen on screen)
   * @param products
   * @return collected in rows
   */
  static getRows(products) {
    let rows = [];
    let alreadyInRow = [];
    products.sort((a, b) => {
      return a.y - b.y;
    });
    for (let i = 0; i < products.length; i++) {
      let row = [];
      let rowBaseY = -1;
      //form row
      for (let j = 0; j < products.length; j++) {
        //if new row, grab first item
        if (row.length == 0) {
          if (!alreadyInRow.includes(j)) {
            row.push(products[j]);
            rowBaseY = products[j].y;
            alreadyInRow.push(j);
          }
        } else {
          //if not already in row and  not that different from base y
          if (
            !alreadyInRow.includes(j) &&
            Math.abs(rowBaseY - products[j].y) <= 5
          ) {
            row.push(products[j]);
            alreadyInRow.push(j);
          }
        }
      }
      //push row to rows array if not empty
      if (row.length != 0) {
        rows.push(row);
      }
    }
    return rows;
  }

  /**
   * creates pallet
   * @param {*} pallet
   */
  static async createPallet(pallet) {
    const client = new HttpClient();
    pallet.height = pallet.pallet_height;
    const response = await client.instance.post("pallets", pallet);
    return response.data;
  }

  /**
   * creates pallet from input with property - owned = false
   * and adds a product to it
   * @param {*} pallet 
   */
  static async createFictivePallet(pallet, order) {
    const client = new HttpClient();
    pallet.pallet_height = pallet.height;
    pallet.owned = 0;
    pallet.spacing_between = 0;
    pallet.spacing_ends = 0;
    pallet.spacing_sides = 0;
    pallet.max_height = 10000;
    pallet.max_weight = 10000;
    pallet.printable = false;
    pallet.status = 2;
    pallet.barcode = true;
    //first create pallet
    const palletResponse = await client.instance.post("pallets", pallet);
    const createdPallet = new Pallet(palletResponse.data);
    //then add product to it
    const product = {
      order_id: order.id,
      pallet_id: createdPallet.id,
      width: pallet.length,
      height: pallet.productHeight,
      depth: pallet.width,
      x: 0,
      y: 0,
      z: 0,
      position: "-",
      barcode: order.production_id.substring(0, 8) + Math.random().toString(36).substring(3, 10),
      weight: 0,
      area: 0
    }
    await client.instance.post("products", product);
    return 1;
  }

  /**
   * generates many pallets
   * @param {*} products
   * @param {*} settings
   */
  static async createPallets(products, settings) {
    const client = new HttpClient();
    //sort products by width first
    products.sort((a, b) => {
      return b.getWidth() - a.getWidth();
    });

    const response = await client.instance.post("pallets/auto", {
      products: products,
      settings: settings
    });
    return response.data;
  }

  /**
   * returns a count of pallets with status > 0
   * @param {} pallets
   */
  static confirmed(pallets) {
    let confirmedCount = 0;
    pallets.forEach(pallet => {
      if (pallet.status > 0) {
        confirmedCount++;
      }
    });
    return confirmedCount;
  }

  /**
   * checks if all given pallets are confirmed
   * @param {*} pallets
   */
  static allConfirmed(pallets) {
    return Pallet.confirmed(pallets) === pallets.length;
  }

  static getPalletsPriority(pallets, orders) {
    if (orders[0].address_based) {
      pallets.forEach(pallet => {
        order: for (let key in orders) {
          const orderGroup = orders[key];
          for (let orderKey in orderGroup.orders) {
            const order = orderGroup.orders[orderKey];
            if (pallet.products[0].order_id == order.id) {
              pallet.dispatch_priority = orderGroup.dispatch_priority;
              break order;
            }
          }
        }
      });
      return pallets;
    }
    pallets.forEach(pallet => {
      const order = pallet.getOrder(orders);
      if (order) {
        pallet.dispatch_priority = order.dispatch_priority;
      }
    });
    return pallets;
  }

  /**
   * updates many pallets with products as given
   * @param {*} pallets
   * @param {*} settings
   */
  static async updatePallets(pallets, ignore) {
    const client = new HttpClient();
    const response = await client.instance.put("pallets", { pallets: pallets, ignore_length: ignore });
    return response.data;
  }

  static async recalculatePalletsBySettings(pallets, packingType) {
    let recalculatedPallets = [];
    pallets.forEach(pallet => {
      //set pallet to new settings
      pallet.pallet_height = packingType.pallet_height
        ? Number.parseInt(packingType.pallet_height)
        : pallet.pallet_height;
      pallet.width = packingType.pallet_width
        ? Number.parseInt(packingType.pallet_width)
        : pallet.width;
      pallet.spacing_between = packingType.spacing_between
        ? Number.parseInt(packingType.spacing_between)
        : pallet.spacing_between;
      pallet.spacing_ends = packingType.spacing_ends
        ? Number.parseInt(packingType.spacing_ends)
        : pallet.spacing_ends;
      pallet.spacing_sides = packingType.spacing_sides
        ? Number.parseInt(packingType.spacing_sides)
        : pallet.spacing_sides;
      pallet.max_weight = packingType.max_weight
        ? Number.parseInt(packingType.max_weight)
        : pallet.max_weight;
      pallet.max_height = packingType.max_height
        ? Number.parseInt(packingType.max_height)
        : pallet.max_height;
      //recalculate pallet
      pallet.moveOld();
      recalculatedPallets.push(pallet);
    });
    await this.updatePallets(recalculatedPallets);
  }

  static async updatePalletByBarcode(barcode) {
    const client = new HttpClient();
    const palletResponse = client.instance.patch(`pallets/scan/${barcode}`);
    return palletResponse;
  }

  getOrderIdsString() {
    let orderIds = [];
    let orderIdsString = "";
    this.products.forEach(product => {
      if (!orderIds.includes(product.order_id)) {
        orderIds.push(product.order_id);
      }
    });
    orderIds.forEach((orderId, index) => {
      orderIdsString += orderId;
      if (index != orderIds.length - 1 && orderIds.length != 1) {
        orderIdsString += ", ";
      }
    });
    return orderIdsString;
  }

  prepareForViewing(divider) {
    this.length /= divider;
    this.width /= divider;
    this.pallet_height /= divider;
    this.spacing_between /= divider;
    this.spacing_ends /= divider;
    this.spacing_sides /= divider;
    this.max_weight /= divider;
    this.max_height /= divider;
    this.divider = divider;
    this.products.forEach(product => {
      product.x /= divider;
      product.y /= divider;
      product.z /= divider;
      product.length /= divider;
      product.height /= divider;
      product.width /= divider;
      product.depth /= divider;
      product.divider = divider;
      product.weight /= divider;
    });
    this.pallet_structure.prepareForViewing(divider);
    return this;
  }


  async saveChanges() {
    let pallet = new Pallet(this);
    const divider = pallet.products[0].divider;
    pallet.length = Math.round(pallet.length * divider);
    pallet.width = Math.round(pallet.width * divider);
    pallet.pallet_height = Math.round(pallet.pallet_height * divider);
    pallet.spacing_between = Math.round(pallet.spacing_between * divider);
    pallet.spacing_ends = Math.round(pallet.spacing_ends * divider);
    pallet.spacing_sides = Math.round(pallet.spacing_sides * divider);
    pallet.max_weight = Math.round(pallet.max_weight * divider);
    pallet.max_height = Math.round(pallet.max_height * divider);
    pallet.products.forEach(product => {
      product.x = Math.round(product.x * divider);
      product.y = Math.round(product.y * divider);
      product.z = Math.round(product.z * divider);
      product.length = Math.round(product.length * divider);
      product.height = Math.round(product.height * divider);
      product.width = Math.round(product.width * divider);
      product.depth = Math.round(product.depth * divider);
      product.weight = Math.round(product.weight * divider);
    });
    const response = await Pallet.updatePallets([pallet]);
    return response;
  }


  /**
 * moves product on the pallet
 * @param layout
 * @param pallet
 */
  moveOld() {
    const layout = this.getLayout();
    let rows = Pallet.getRows(layout);
    let recalculatedProducts = [];
    let currentY = this.spacing_sides; // y coordinate of product currently counting
    rows.forEach(row => {
      let currentX = this.spacing_ends; // x coordinate of product currently counting
      row.sort((a, b) => {
        return a.x - b.x;
      });
      row.forEach(product => {
        //if there are pallets stacked move them too
        if (product.stacked != null) {
          product.stacked.forEach(stackItem => {
            stackItem.x = currentX;
            stackItem.y = currentY;
            recalculatedProducts.push(stackItem);
          });
        }
        // form array of pallet data to update
        product.product.x = currentX;
        product.product.y = currentY;
        product.product.z = 0;
        recalculatedProducts.push(product.product);
        currentX += product.product.getWidth();
        if (row.length == 2) {
          let takenUpSpace = this.spacing_ends * 2;
          row.forEach(product => {
            takenUpSpace += product.product.getWidth();
          });
          if (takenUpSpace < this.length) {
            currentX =
              this.length - this.spacing_ends - row[1].product.getWidth();
          }
        }
      });
      currentY +=
        Math.max.apply(
          Math,
          row.map(o => {
            return o.product.depth;
          })
        ) + this.spacing_between;
    });
    this["products"] = recalculatedProducts;
    this.length = this.minDimensions().length;
    return recalculatedProducts; //return where to move
  }

  static async updateByBarcode(barcode, data) {
    const client = new HttpClient();
    const response = await client.instance.patch(`pallets/scan/${barcode}`, data);
    return response.data;
  }

  /**
   * return if truck is within bounds of truck
   * (only check truck width)
   * @param {Truck} truck 
   * @return true false
   */
  fits(truck) {
    const divider = truck.divider ? truck.divider : 1;
    if (this.truck_y < 0) {
      return false;
    }
    if ((this.truck_y + this.getWidth()) * divider > truck.width * divider) {
      return false;
    }
    return true;
  }

  /**
   * checks if pallets not on top of each other
   * @param {Pallet} otherPallet 
   */
  intersects(otherPallet) {
    return !(otherPallet.truck_x >= (this.truck_x + this.getLength()) ||
      (otherPallet.truck_x + otherPallet.getLength()) <= this.truck_x ||
      otherPallet.truck_y >= (this.truck_y + this.getWidth()) ||
      (otherPallet.truck_y + otherPallet.getWidth()) <= this.truck_y);
  }

  static copyPallets(pallets) {
    const newPallets = [];
    pallets.forEach(pallet => {
      newPallets.push(new Pallet(pallet));
    });
    return newPallets;
  }

  /**
   * moves pallet as left as possible within truck
   * @param {*} movedLeft - pallets already moved left
   */
  moveLeft(movedLeft, spacing) {
    //find right most pallet within movedLeft pallets
    //where pallet y border intersects
    let rightMostPallet = null;
    for (const pallet of movedLeft) {
      //if pallet within relevant height
      if (!(pallet.truck_y >= (this.truck_y + this.getWidth()) ||
        (pallet.truck_y + pallet.getWidth()) <= this.truck_y)) {
        if (rightMostPallet == null) {
          rightMostPallet = pallet;
          continue;
        }
        //if more right save current pallet
        if (pallet.truck_x + pallet.getLength() > rightMostPallet.truck_x + rightMostPallet.getLength()) {
          rightMostPallet = pallet;
        }
      }
    }
    //if no more moved or relevant pallets
    // pallets move to corner
    if (rightMostPallet == null) {
      this.truck_x = 0;
      return;
    }
    this.truck_x = rightMostPallet.truck_x + rightMostPallet.getLength() + spacing / this.divider;
    return;
  }

  /**
   * moves pallets as up as possible within truck
   * @param {*} movedLeft - all pallets moved up until now
   */
  moveUp(movedUp) {
    //find the bottom most pallet where x borders intersec
    let bottomMostPallet = null;
    for (const pallet of movedUp) {
      //if pallet within relevant width
      if (!(pallet.truck_x >= (this.truck_x + this.getLength()) ||
        (pallet.truck_x + pallet.getLength()) <= this.truck_x)) {
        if (bottomMostPallet == null) {
          bottomMostPallet = pallet;
          continue;
        }
        //if more down, save current pallet
        if (pallet.truck_y + pallet.getWidth() > bottomMostPallet.truck_y + bottomMostPallet.getWidth()) {
          bottomMostPallet = pallet;
        }
      }
    }
    //if there are no moved or relevant pallets, move to top
    if (bottomMostPallet == null) {
      this.truck_y = 0;
      return;
    }
    this.truck_y = bottomMostPallet.truck_y + bottomMostPallet.getWidth();
    return;
  }

  getOrdersFromNumber() {
    if (this.order_number == null) {
      return [];
    }
    let orders = this.order_number.split(", ");
    return orders;
  }

  static getOwnedPallets(pallets) {
    return pallets.filter(pallet => {
      return pallet.owned;
    })
  }
}
